export { default as useGetRedirectUrl } from "./useGetRedirectUrl";
